require('./stylesheets/userSettings.scss');

angular.module('pages.userSettings', [])
	.config(config);

config.$inject = ['$stateProvider'];

function config($stateProvider) {
	$stateProvider
		.state('pages.user-settings', {
			url: 'settings',
			template: require('./templates/index.html'),
			controller: require('./controllers/userSettings.controller'),
			data: {
				iframe: false
			},
			pageTrack: '/userSettings'
		})
}

module.exports = 'pages.userSettings';



/*****************
 ** WEBPACK FOOTER
 ** ./app/pages/userSettings/index.js
 ** module id = 299
 ** module chunks = 1
 **/